import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PaymentCart } from '@cargos/sprintpay-models';
import { Subject, map, takeUntil } from 'rxjs';
import { PaymentCartTypeType } from 'src/app/shared/models/payment-type';
import { CartBillService } from 'src/app/shared/services';
import { PaymentCartTypeHandlerService } from 'src/app/shared/services/payment-cart-type-handler.service';
import { Identifiers } from '../../../shared/constants/identifiers';

@Component({
    selector: 'app-flight-section',
    templateUrl: './flight-section.component.html',
    styleUrl: './flight-section.component.scss',
    standalone: false,
})
export class FlightSectionComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    public flightNumber = '';
    public panelOpenState = false;
    public allPayments: PaymentCart[] = [];
    public flightIdentifier = Identifiers;
    public displayPartLabel = true;
    public displayOnlyAwb = true;
    public isOpenCloseDropDown = false;

    @Input() index = 0;
    @Input() awb = '';
    @Input() aboveThreshold: boolean;
    @Input() set panelOpen(value: boolean) {
        this.panelOpenState = value;
    }
    @Input()
    set flightPayments(flightPayments: PaymentCart[]) {
        this.allPayments = flightPayments;
        this.getFlight();
    }

    constructor(
        private cartBillService: CartBillService,
        private paymentCartTypeHandlerService: PaymentCartTypeHandlerService
    ) {}

    ngOnInit(): void {
        this.getCartPaymentType();
        this.subscribeCart();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getCartPaymentType(): void {
        this.paymentCartTypeHandlerService
            .getPaymentCartType()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (paymentCartTypeType) => {
                    this.displayPartLabel = paymentCartTypeType !== PaymentCartTypeType.HAWB;
                },
            });
    }

    getFlight(): void {
        this.flightNumber = this.allPayments?.[0]?.externalData?.flightNumber || '';
    }

    subscribeCart(): void {
        this.cartBillService
            .getCart$()
            .pipe(
                takeUntil(this.unsubscribe$),
                map((carts: PaymentCart[]) => {
                    return carts.map((cart: PaymentCart) => cart.externalData?.flightNumber);
                })
            )
            .subscribe((flightNumbers) => {
                this.displayOnlyAwb = [...new Set(flightNumbers)].length === 1 ? true : false;
            });
    }

    onOpenCloseDropDown(): void {
        this.isOpenCloseDropDown = !this.isOpenCloseDropDown;
    }
}
